
import { Component, Prop, Vue } from "vue-property-decorator";

export enum Variant {
  success = "SUCCESS",
  warning = "WARNING",
  error = "ERROR",
}

@Component({ model: { prop: "visible", event: "change" } })
export default class NotificationModal extends Vue {
  @Prop({ default: false }) visible!: boolean;
  @Prop({ default: Variant.success }) variant!: Variant;
  @Prop({ default: "" }) message!: string;
  @Prop({ default: [] }) additionalMessages!: string[];

  handleVisibilityChange(visible: boolean) {
    this.$emit("change", visible);
  }

  get headerBgVariant(): string {
    switch (this.variant) {
      case Variant.success:
        return "success";
      case Variant.warning:
        return "warning";
      case Variant.error:
        return "danger";
      default:
        return "success";
    }
  }

  get headerTextVariant(): string {
    switch (this.variant) {
      case Variant.success:
        return "light";
      case Variant.warning:
        return "dark";
      case Variant.error:
        return "light";
      default:
        return "light";
    }
  }
}
